import {
  ROLES,
  type RoleStrategy,
  api,
  useQuery,
  useQueryClient,
  useRoleConf,
} from "@pharmupp/p3-front-commons"

export const useGetCommitteeLink = () => {
  const { link } = useRoleConf(committeeAccessConf)

  return useQuery({
    queryKey: link.queryKey,
    queryFn: () => api.get<{ link: string }>(link.endpoint),
    staleTime: 0,
    gcTime: 0,
  })
}

export const useCommitteeStatus = () => {
  const { status, link } = useRoleConf(committeeAccessConf)
  const queryClient = useQueryClient()

  const { data: accessStatus, isLoading } = useQuery({
    queryKey: status.queryKey,
    queryFn: () => api.get<{ isActive: boolean }>(status.endpoint),
  })

  const linkQueryState = queryClient.getQueryState(link.queryKey)

  return {
    accessStatus: accessStatus?.isActive ?? false,
    isLoading,
    linkLoading:
      !!linkQueryState &&
      (linkQueryState.status === "pending" ||
        linkQueryState.fetchStatus === "fetching"),
  }
}

const adhConf = {
  status: {
    endpoint: "/api/employee-committees/adherent/my-access/status",
    queryKey: ["employee-committees", "adherent", "/my-access", "status"],
  },
  link: {
    endpoint: "/api/employee-committees/adherent/my-access/link",
    queryKey: ["employee-committees", "adherent", "/my-access", "link"],
  },
}

export const committeeAccessConf: RoleStrategy<{
  status: { endpoint: string; queryKey: string[] }
  link: { endpoint: string; queryKey: string[] }
}> = {
  [ROLES.ADHERENT_HOLDER]: adhConf,
  [ROLES.ADHERENT_TEAM]: adhConf,
}
